import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-mesh">
      <div className="animate-fade-in-up text-center">
        <h1 className="mb-2 font-heading text-7xl font-bold bg-gradient-to-r from-primary to-sky-300 bg-clip-text text-transparent">
          404
        </h1>
        <h2 className="mb-4 font-heading text-xl font-semibold text-text-primary">
          Page Not Found
        </h2>
        <p className="mb-8 font-body text-text-muted">
          The page you are looking for does not exist.
        </p>
        <Link
          to="/"
          className="inline-block rounded-xl bg-gradient-to-r from-primary to-sky-400 px-6 py-3 font-body font-semibold text-white shadow-md transition-all hover:shadow-lg hover:shadow-primary/20 hover:-translate-y-0.5 active:translate-y-0"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
}
